module.exports = __webpack_public_path__ + "static/img/s18.f0a1ad77.png";